import {assert} from 'Asserts';
import {Feature} from 'auth/feature-enablement/FeatureConstants';
import {listToReadable} from 'util/NameUtil';

import {
  ApplicationName,
  Capability,
  CAPABILITY_TO_FEATURE_TYPE,
  CAPABILITY_TO_NAME,
  UserPreferenceGatedCapability,
} from './CapabilityFeatureConstants';

function _getApplicationNameForFeature(feature: Feature): ApplicationName {
  let applicationNameForFeature: ApplicationName | null = null;
  for (const [capability, featureList] of Object.entries(CAPABILITY_TO_FEATURE_TYPE)) {
    if (Object.keys(featureList).includes(feature)) {
      applicationNameForFeature = CAPABILITY_TO_NAME[capability as Capability];
      break;
    }
  }
  assert(applicationNameForFeature != null, 'All features should map to an application name.');
  return applicationNameForFeature;
}

// Exported for tests
export function _getUniqueUserFacingCapabilityNameList(features: Array<Feature>): Array<ApplicationName> {
  // eslint-disable-next-line no-restricted-syntax
  return Array.from(new Set(features.map((feature) => _getApplicationNameForFeature(feature)))).sort();
}

export function makeMissingCapabilityUserMessage(features: Array<Feature>): string {
  assert(Boolean(features.length), 'Expected at least one feature');

  const names = _getUniqueUserFacingCapabilityNameList(features);
  assert(Boolean(names.length), 'All features should return an application name');

  return makeUserMessage(names);
}

// This function should only be used with FeatureConstants.USER_PREFERENCE_GATED_CAPABILITIES
// because they do not have features defined for them. For all other capabilities,
// use makeMissingCapabilityUserMessage().
export function makeMissingMessageForUserPrefGatedCapabilities(
  capabilities: Array<UserPreferenceGatedCapability>
): string {
  assert(Boolean(capabilities.length), 'Expected at least one capability');
  const names = capabilities.map((capability) => CAPABILITY_TO_NAME[capability]);
  return makeUserMessage(names);
}

function makeUserMessage(names: Array<string>): string {
  return `Opening this item requires access to the ${listToReadable(
    names,
    'or'
  )} application. Contact your administrator for access.`;
}
